import { render, staticRenderFns } from "./LiShiMingDan.vue?vue&type=template&id=6b0e6438&scoped=true&"
import script from "./LiShiMingDan.vue?vue&type=script&lang=js&"
export * from "./LiShiMingDan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e6438",
  null
  
)

export default component.exports